import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { TaxesTemplate } from '@components/templates'

const Taxes = ({ pagina }) => <TaxesTemplate pagina={pagina} />

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'taxes', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina },
      revalidate: 60 * 20,
    }
  },
  '/taxes'
)

export default Taxes
